import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrWithdrawalStatus.ts
var t = () => e("withdrawalStatus");
//#endregion
export { t as useTrWithdrawalStatus };
